import styled from 'styled-components';

import { Heading } from '@dreryk/react-components';

export const StyledTotalGrossPrice = styled(Heading)`
   display: flex;
   justify-content: flex-end;
   align-items: baseline;
   gap: 8px;
   margin-right: 84px;
`;
StyledTotalGrossPrice.displayName = 'StyledTotalGrossPrice';
